/**
 * Fix for iOS Safari viewport height issue
 * Sets CSS custom property --vh to the actual viewport height
 * This accounts for browser chrome (address bar + bottom toolbar)
 */

const setViewportHeight = () => {
    // Get the actual viewport height and multiply by 1% to get a value for 1vh
    const vh = window.innerHeight * 0.01;
    // Set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Set on load
setViewportHeight();

// Re-calculate on resize (when address bar shows/hides on iOS)
window.addEventListener('resize', setViewportHeight);

// Re-calculate on orientation change
window.addEventListener('orientationchange', setViewportHeight);

export default setViewportHeight;
